import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en.json'; //English
import frTranslation from './locales/fr.json'; //French
import heTranslation from './locales/he.json'; //Hebrew
import ptTranslation from './locales/pt.json'; //Portuguese
import esTranslation from './locales/es.json'; //Spanish
import jaTranslation from './locales/ja.json'; //Japanese

async function initI18n() {
  const defaultLanguage = 'en';

  i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: enTranslation,
      },
      fr: {
        translation: frTranslation,
      },
      he: {
        translation: heTranslation,
      },
      pt: {
        translation: ptTranslation,
      },
      es: {
        translation: esTranslation,
      },
      ja: {
        translation: jaTranslation,
      },
    },
    lng: defaultLanguage, // Use the fetched default language as the initial language
    fallbackLng: 'en', // Fallback language if the detected language is not available
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values, so no need for extra escaping
    },
  });
}

initI18n();

export default i18n;
